export enum DialogSymbol {
  Talk = "dialog_talk",
  Done = "dialog_done",
  Task = "dialog_task",
  Fixed = "dialog_fixed"
}